export default "<p>reset-password works!</p>\n"